import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import SEED_JUNIORS from "../../data/staffing/seed-juniors";

const SectionStyled = styled.section`
  padding: 96px 0;
  background: var(--nd-black);
`;

const Label = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-secondary);
  margin: 0 0 16px;
`;

const Title = styled.h1`
  font-family: 'Doto', 'Space Mono', monospace;
  font-size: 48px;
  font-weight: 700;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin: 0 0 12px;
  @media (max-width: 768px) { font-size: 32px; }
`;

const Subtitle = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0 0 32px;
`;

const Card = styled.div`
  background: var(--nd-surface);
  border: 1px solid var(--nd-border);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  height: 100%;
`;

const CardName = styled.h3`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: var(--nd-text-display);
  margin: 0 0 8px;
  letter-spacing: 0.02em;
`;

const CardMeta = styled.p`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin: 0 0 16px;
`;

const SkillRow = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

const SkillChip = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.06em;
  color: var(--nd-text-secondary);
  background: rgba(255,255,255,0.03);
  padding: 2px 8px;
  border-radius: 4px;
`;

const obscure = (name) => name.replace(/[a-zA-ZÀ-ÿ]/g, "█");

const JuniorStaffingPreview = () => (
  <SectionStyled>
    <Container>
      <Label>JUNIOR STAFFING · PREVIEW</Label>
      <Title>Available juniors</Title>
      <Subtitle>Names hidden. Sign in as staff to see the full roster.</Subtitle>
      <Row>
        {SEED_JUNIORS.slice(0, 3).map((j) => (
          <Col md="4" className="mb-4" key={j.id}>
            <Card>
              <CardName>{obscure(j.name)}</CardName>
              <CardMeta>{j.role} · {j.yearsOfExperience}y · {j.location}</CardMeta>
              <SkillRow>
                {j.skills.slice(0, 3).map((s) => <SkillChip key={s}>{s}</SkillChip>)}
              </SkillRow>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </SectionStyled>
);

export default JuniorStaffingPreview;
